var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Pdf Viewer","active":_vm.active},on:{"close":function($event){return _vm.$emit('cancel')}}},[_c('div',{staticClass:"alert-message"},[_c('div',{attrs:{"id":"adobe-dc-view"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }